/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Mirrors backend `UPS.Viewpoint.DTO.Common.ParentFacilityDropdownDto`
 * returned from `/api/parentFacilities` and `/api/quotelog/facilities`.
 *
 * VPParentFacilityKeyID semantics (from backend xmldoc):
 *  - vp-api: budFacility.KeyID column
 *  - sparta-api: pkKey column
 * Do NOT use budParentFacility.pkKey — it is not unique.
 */
export interface ParentFacilityDropdownDto {
  ParentFacilityID: number;
  City: string;
  State: string;
  ZIP: string;
  FacilityName: string;
  DisplayName: string;
  Address: string;
  ParentCustomerName: string;
  ParentCustomerID: number;
  IsActive: boolean;
  IsUserFavorite: boolean;
  VPParentFacilityKeyID: number;
  EndMarket: string;
}
